import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const SignInDirective = angularDirectiveToReact('onboardingLogin', {});

export function SignInComponent() {
    const [key] = useAngularToReactRoute();
    return <SignInDirective key={key} />;
}
